module.exports = __webpack_public_path__ + "img/Flag_of_Bangladesh.73c177e4.svg";